"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWhiteSpace = exports.replaceSuggestionTagWithStrongTag = exports.showFeedbackModule = exports.shouldShowFeedback = exports.arrayMoveIndex = exports.getDateAndTime = exports.generateIconName = exports.copyToClipboard = exports.shouldDisplayUnassignBtn = exports.assignedOrUnassignedUser = exports.isUserMatchingSearchValue = exports.displaySubtitle = exports.joinStringsIntoCommaSeparatedString = exports.joinDisplayNamesIntoCommaSeparatedString = exports.isRTLTextDirection = exports.appendQueryParams = exports.addTagsAndReplaceNbspSpecialCharacters = exports.convertTime12to24 = exports.getSecondaryTaskLocale = exports.globalAxiosInstanceErrorInterceptor = exports.constructImgUrl = exports.createRandomUUID = exports.arrayToObject = exports.ifTodayHideDate = exports.getHoursToExpiry = exports.isTodaysDate = exports.formatDateInFormat = exports.formatDateAsTime = exports.ISOStringDateToLocalDate = exports.ISOStringDateToLocalTime = exports.stringByteLength = exports.userHasPermission = exports.getInitials = exports.displayDateAndTimeWithYear = exports.displayDateAndTime = exports.findTimeIndexForTimesArr = exports.roundWithAmPm = exports.roundMinutes = exports.addHoursAndSetMinutes = exports.calculateHoursAndMinutesForMaxBoundary = exports.calculateHoursAndMinutesForMinBoundary = exports.resetSecondsAndMilliseconds = exports.getFirstNameAndInitials = exports.toCamelCase = exports.fromSnakeCaseToWords = exports.fromCamelCaseToWords = exports.joinStringsWithComma = exports.joinStringsWithColon = exports.getV1NamespaceFromV2WorkflowIdentifier = exports.WORKFLOW_IDENTIFIERS = exports.showV2Design = void 0;
const moment_1 = __importDefault(require("moment"));
const lodash_1 = require("lodash");
exports.showV2Design = () => process.env.REACT_APP_ENV === 'localhost' &&
    window.localStorage.getItem('showV2Design') === 'true';
exports.WORKFLOW_IDENTIFIERS = {
    appscanvas: 'ed-apps-canvas-workflow',
    musiccontent: 'ed-music-content-workflow',
    videocontent: 'ed-video-content-workflow',
    copyworkflow: 'ed-copy-workflow'
};
exports.getV1NamespaceFromV2WorkflowIdentifier = (v2Identifier) => {
    return (Object.keys(exports.WORKFLOW_IDENTIFIERS).find((key) => exports.WORKFLOW_IDENTIFIERS[key] === v2Identifier) ||
        '');
};
exports.joinStringsWithColon = (values) => values.map((value) => value.displayName).join('; ');
exports.joinStringsWithComma = (values) => values.join(', ');
exports.fromCamelCaseToWords = (string) => string
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, function (str) {
    return str.toUpperCase();
});
exports.fromSnakeCaseToWords = (value) => lodash_1.startCase(lodash_1.lowerCase(value));
exports.toCamelCase = (str) => str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (i, chr) => chr.toUpperCase());
exports.getFirstNameAndInitials = (fullName) => {
    if (!(fullName === null || fullName === void 0 ? void 0 : fullName.length))
        return 'Unknown';
    const fullNameArr = fullName.split(' ').filter((nameParts) => nameParts[0] !== '(') || [];
    const firstName = fullNameArr[0];
    const initials = fullNameArr === null || fullNameArr === void 0 ? void 0 : fullNameArr.map((nameItem) => nameItem[0].toUpperCase()).slice(1).join('.');
    if (initials.length)
        return `${firstName} ${initials}.`;
    if (firstName)
        return `${firstName}`;
};
exports.resetSecondsAndMilliseconds = (date) => {
    return moment_1.default(date).set('second', 0).set('millisecond', 0).toString();
};
exports.calculateHoursAndMinutesForMinBoundary = (date, minutes) => {
    if (minutes < 30) {
        return exports.addHoursAndSetMinutes(date, 0, 30);
    }
    return exports.addHoursAndSetMinutes(date, 1, 0);
};
exports.calculateHoursAndMinutesForMaxBoundary = (date, minutes) => {
    if (minutes === 0) {
        return exports.addHoursAndSetMinutes(date, -1, 30);
    }
    if (0 < minutes && minutes <= 30) {
        return exports.addHoursAndSetMinutes(date, 0, 0);
    }
    return exports.addHoursAndSetMinutes(date, 0, 30);
};
exports.addHoursAndSetMinutes = (date, hours, minutes) => {
    const dateWithNewHoursAndMinutes = moment_1.default(date).add(hours, 'hours').set('minutes', minutes);
    return exports.resetSecondsAndMilliseconds(dateWithNewHoursAndMinutes);
};
exports.roundMinutes = (date, min) => {
    const minutes = moment_1.default(date).minutes();
    return min
        ? exports.calculateHoursAndMinutesForMinBoundary(date, minutes)
        : exports.calculateHoursAndMinutesForMaxBoundary(date, minutes);
};
exports.roundWithAmPm = (date, min) => moment_1.default(exports.roundMinutes(date, min)).format('h:mmA');
exports.findTimeIndexForTimesArr = (timesArr, timeToCompare, min) => {
    const time = exports.roundWithAmPm(timeToCompare, min);
    return timesArr.indexOf(time);
};
exports.displayDateAndTime = (value) => `${moment_1.default(value).format('MMM DD')}, ${moment_1.default(value).format('h:mmA')}`;
exports.displayDateAndTimeWithYear = (dateTime) => moment_1.default(dateTime).format('MMM DD YYYY, hh:mm A');
exports.getInitials = (fullName = '') => {
    if (!fullName)
        return '';
    const names = fullName.split(' ').filter((nameParts) => nameParts[0] !== '(');
    let initials = names[0].substring(0, 1).toUpperCase();
    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
};
exports.userHasPermission = (userPermissions, permissionToCheck) => {
    if (!userPermissions || !userPermissions.length)
        return false;
    if (Array.isArray(permissionToCheck)) {
        if (!permissionToCheck || !permissionToCheck.length)
            return true;
        return lodash_1.intersection(userPermissions, permissionToCheck).length >= 1;
    }
    else {
        return userPermissions.indexOf(permissionToCheck) >= 0;
    }
};
exports.stringByteLength = (text) => {
    if (!(text === null || text === void 0 ? void 0 : text.length))
        return 0;
    let byteLength = text.length;
    for (let i = 0; i < text.length; i++) {
        const db = text[i].charCodeAt(0).toString(16).length == 4;
        if (db)
            byteLength++;
    }
    return byteLength;
};
const isStringValidDate = (dateString) => {
    const dateTimestamp = Date.parse(dateString);
    return !isNaN(dateTimestamp);
};
const addColonToISOTimezoneOffset = (dateString) => {
    return dateString.replace(/([+\-]\d\d)(\d\d)$/, '$1:$2');
};
const extractDateIntoDigitsAndString = (date) => {
    return {
        y: date.getFullYear(),
        yy: date.getFullYear().toString().substring(2),
        M: date.getMonth() + 1,
        MM: date.toLocaleString('default', { month: 'short' }),
        MMMM: date.toLocaleString('default', { month: 'long' }),
        d: date.getDate(),
        h: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds()
    };
};
const prependZeroToDigit = (num) => {
    return num >= 0 && num <= 9 ? `0${num}` : `${num}`;
};
exports.ISOStringDateToLocalTime = (isoStringDate) => {
    if (isoStringDate.length === 0)
        return isoStringDate;
    let dt = new Date(isoStringDate);
    let hh = prependZeroToDigit(dt.getHours());
    let mm = prependZeroToDigit(dt.getMinutes());
    let ss = prependZeroToDigit(dt.getSeconds());
    return `${hh}:${mm}:${ss}`;
};
exports.ISOStringDateToLocalDate = (isoStringDate) => {
    if (isoStringDate.length === 0)
        return isoStringDate;
    let dt = new Date(isoStringDate);
    let dd = prependZeroToDigit(dt.getDate());
    let mm = prependZeroToDigit(dt.getMonth() + 1);
    let yyyy = prependZeroToDigit(dt.getFullYear());
    return `${yyyy}-${mm}-${dd}`;
};
exports.formatDateAsTime = (date) => {
    const dateObj = extractDateIntoDigitsAndString(date);
    return `Today ${dateObj.h}:${dateObj.m}`;
};
exports.formatDateInFormat = (dateString, format) => {
    const dateStringWithTimezoneColon = addColonToISOTimezoneOffset(dateString);
    if (!isStringValidDate(dateStringWithTimezoneColon))
        return 'Invalid date';
    const date = new Date(dateStringWithTimezoneColon);
    const dateObject = extractDateIntoDigitsAndString(date);
    switch (format) {
        case 'yyyy-mm-dd':
            return `${dateObject.y}-${dateObject.M}-${dateObject.d}`;
        case 'mm/dd/yy':
            return `${dateObject.M}/${dateObject.d}/${dateObject.yy}`;
        case 'tidbits_calendar':
            return `${dateObject.MMMM} ${dateObject.d}, ${dateObject.y}`;
        case 'time':
            return `Today ${dateObject.h}:${dateObject.m}h`;
        case 'time_short':
            return moment_1.default(dateString).format('hh:mm A');
        case 'short_date':
        default:
            return `${dateObject.d} ${dateObject.MMMM} ${dateObject.y}`;
    }
};
exports.isTodaysDate = (timestamp) => {
    const today = new Date();
    const date = new Date(timestamp);
    return today.toDateString() === date.toDateString();
};
exports.getHoursToExpiry = (date) => {
    const MS_IN_HOUR = 1000 * 60 * 60;
    const today = new Date().getTime();
    const dueDate = new Date(date).getTime();
    const timeLeft = dueDate - today;
    return Math.round(timeLeft / MS_IN_HOUR);
};
exports.ifTodayHideDate = (timestamp) => exports.isTodaysDate(timestamp)
    ? 'Today ' + moment_1.default(timestamp).format('h:mmA')
    : moment_1.default(timestamp).format('MMMM Do YYYY, h:mmA');
exports.arrayToObject = (array, keyField, additionalKey = '') => array.reduce((obj, item) => {
    obj[item[keyField] + additionalKey] = item;
    return obj;
}, {});
exports.createRandomUUID = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random % 4) + 8;
    return value.toString(16);
});
exports.constructImgUrl = (imgUrl, width, height, cropCode = 'bb', format = 'png') => {
    if (imgUrl === null || imgUrl === '')
        return '';
    return imgUrl
        .replace('{w}', `${width}`)
        .replace('{h}', `${height}`)
        .replace('{c}', cropCode)
        .replace('{f}', format);
};
exports.globalAxiosInstanceErrorInterceptor = (status, forbiden, notAuthenticated, toastMessage) => {
    switch (status) {
        case 401:
            notAuthenticated && notAuthenticated();
            break;
        case 403:
        case 404:
            forbiden && forbiden();
            break;
        case 500:
            toastMessage && toastMessage();
            break;
        default:
            break;
    }
};
const getAdaptedLocaleKey = (key) => {
    if (!key)
        return '';
    return key.split('-').length > 1 ? key.split('-')[1] : key.split('-')[0];
};
exports.getSecondaryTaskLocale = (taskSecondary) => {
    const { locale: { displayName, key } } = taskSecondary;
    switch (displayName) {
        case 'de':
            return `Germany (${getAdaptedLocaleKey(key)})`;
        case 'ch':
            return `Switzerland (${getAdaptedLocaleKey(key)})`;
        case 'en':
            return `English (${getAdaptedLocaleKey(key)})`;
        case 'es':
            return `Spanish (${getAdaptedLocaleKey(key)})`;
        case 'mx':
            return `Mexican (${getAdaptedLocaleKey(key)})`;
        default:
            return '';
    }
};
exports.convertTime12to24 = (time12h) => {
    const ampm = time12h.slice(-2).toUpperCase();
    const time = time12h.slice(0, -2);
    const [hours, minutes] = time.split(':');
    if (ampm === 'PM') {
        return [`${parseInt(hours === '12' ? '00' : hours, 10) + 12}`, minutes];
    }
    return [hours === '12' ? '00' : hours, minutes];
};
exports.addTagsAndReplaceNbspSpecialCharacters = (contentWithSpecialCharactersInsteadOfQuillNbspTags) => {
    const openingTag = '<my-tag-non-breaking class="mpe-quill-non-breaking mpe-quil-non=breaking-transparent" contenteditable="false">';
    const closingTag = '</my-tag-non-breaking>';
    const delimiterPattern = /([^\s>][A-z]+\u00A0[^\s<]+)/g;
    const contentWithSpecialCharactersInsteadOfQuillNbspTagsSplit = contentWithSpecialCharactersInsteadOfQuillNbspTags.split(delimiterPattern);
    let output = '';
    for (const token of contentWithSpecialCharactersInsteadOfQuillNbspTagsSplit) {
        let exec;
        if ((exec = /([^\s>][A-z]+\u00A0[^\s<]+)/.exec(token))) {
            const content = exec[0].replace(/\u00A0/g, ' ');
            output += `${openingTag}${content}${closingTag}`;
        }
        else {
            output += token;
        }
    }
    return output;
};
exports.appendQueryParams = (queryParams) => {
    if (!queryParams)
        return '';
    return Object.entries(queryParams).reduce((prevQuery, currQuery) => {
        return `${prevQuery};${currQuery[0]}==${encodeURIComponent(currQuery[1])}`;
    }, '');
};
exports.isRTLTextDirection = (locale) => {
    const RTLTextLocales = ['he-IL', 'ar-SA'];
    return RTLTextLocales.includes(locale);
};
exports.joinDisplayNamesIntoCommaSeparatedString = (list) => `${list.map((item) => item.displayName).join(', ')}`;
exports.joinStringsIntoCommaSeparatedString = (items) => (items === null || items === void 0 ? void 0 : items.join(', ')) || '';
exports.displaySubtitle = (locale) => {
    if (!locale)
        return '';
    return `${locale === null || locale === void 0 ? void 0 : locale.displayName} [${locale === null || locale === void 0 ? void 0 : locale.key}]`;
};
exports.isUserMatchingSearchValue = (user, searchValue) => user.name.toLowerCase().includes(searchValue.toLowerCase());
exports.assignedOrUnassignedUser = (assignee) => (Object.assign({}, (!assignee ? { key: 'Unassigned', displayName: 'Unassigned' } : assignee)));
exports.shouldDisplayUnassignBtn = (displayName) => displayName !== 'Unassigned';
exports.copyToClipboard = (value, hide) => {
    navigator.clipboard.writeText(value);
    hide();
};
exports.generateIconName = (str, registeredShelves) => { var _a; return ((_a = registeredShelves[str]) === null || _a === void 0 ? void 0 : _a.icon) || 'shelfNameThin'; };
exports.getDateAndTime = (timeString) => {
    if (timeString === null)
        return '-';
    return `${exports.formatDateInFormat(timeString, 'mm/dd/yy')}, ${exports.formatDateInFormat(timeString, 'time_short')}`;
};
exports.arrayMoveIndex = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
        let n = new_index - arr.length + 1;
        while (n--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
};
exports.shouldShowFeedback = (stateAndStatus) => {
    return (stateAndStatus === 'Review (Onsite Review)' ||
        stateAndStatus === 'Review (Internal Review)' ||
        stateAndStatus === 'Review (Review)' ||
        stateAndStatus === 'Review (Adaptation Review)' ||
        stateAndStatus === 'Exported (Review)' ||
        stateAndStatus === 'Imported (Review)' ||
        stateAndStatus === 'Imported (Onsite Review)');
};
exports.showFeedbackModule = (stateAndStatus, isRejectAction) => {
    return (exports.shouldShowFeedback(stateAndStatus) ||
        (isRejectAction && stateAndStatus !== 'Analyze (Analyze Request)'));
};
exports.replaceSuggestionTagWithStrongTag = (text) => {
    const regex = /<suggestion>(.*?)<\/suggestion>/g;
    return text.replace(regex, '<strong>$1</strong>');
};
exports.isWhiteSpace = (str) => str.trim() === '';
